<template>
  <form
    id="cashsubmit"
    autocomplete="off"
    method="POST"
    @submit.prevent="onSubmit"
  >
    <div v-if="actionTypeTemp === 'deposit'" class="row justify-content-center">
      <div class="col-12 mb-1">
        <div class="col-12 text-center mt-3 text-lg">ฝาก : เลือกธนาคาร</div>
        <div class="form-group my-3 row">
          <div
            v-for="bank in agentBanks"
            :key="bank.account_number"
            class="text-center col-4 col-md-4 col-lg-2"
          >
            <img
              :src="bank.logo_url"
              alt=""
              width="100%"
              class="max-width-200x border border-lg rounded-lg px-2 py-2 mb-1"
              :for="bank.account_number"
              :class="[selectedAgentBankId === bank.id ? 'border-yellow' : '']"
              @click="selectedBank($event, bank.bank, bank.id)"
            /><br />
            <font :class="'text-lg text-' + bank.bank">
              {{ bank.thai_name }}
            </font>
          </div>
        </div>
        <div class="form-group my-3">
          <cash-input
            element-id="amount"
            element-name="amount"
            element-type="tel"
            element-class="text-center text-xl"
            element-placeholder="ระบุจำนวนเงินที่ต้องการฝาก"
            :amount="amount"
            @updateAmountValue="updateAmountValue"
          />
        </div>
        <p class="text-xs text-center text-danger">
          ใส่ยอดเป็นจำนวนเต็ม ระบบจะทำการสุ่มทศนิยมให้ท่านอัติโนมัติ
        </p>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="50"
          type="button"
          @click="updateAmount(50)"
        >
          50
        </button>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="100"
          type="button"
          @click="updateAmount(100)"
        >
          100
        </button>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="300"
          type="button"
          @click="updateAmount(300)"
        >
          300
        </button>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="500"
          type="button"
          @click="updateAmount(500)"
        >
          500
        </button>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="1000"
          type="button"
          @click="updateAmount(1000)"
        >
          1,000
        </button>
      </div>
      <div class="col-4 col-lg-2 text-center mt-3">
        <button
          class="btn btn-outline-dark w-100 btnValue"
          data-valueset="2000"
          type="button"
          @click="updateAmount(2000)"
        >
          2,000
        </button>
      </div>
      <div class="col-12">
        <div class="d-flex">
          <div class="flex-width text-left text-dark">หมายเหตุ</div>
        </div>
        <div class="d-flex py-3">
          <input v-model="remark" type="text" class="form-control" />
        </div>
      </div>
      <div class="col-4 my-5">
        <button class="btn btn-primary w-100 shadow" type="reset">
          ยกเลิก
        </button>
      </div>
      <div class="col-8 my-5">
        <button class="btn btn-green w-100 shadow" type="submit">ยืนยัน</button>
      </div>
    </div>
    <div
      v-else-if="actionTypeTemp === 'withdraw'"
      class="row justify-content-center"
    >
      <div class="col-12 text-center mt-3 text-lg">ถอนเครดิต</div>
      <div class="col-12">
        <div class="form-group my-3">
          <cash-input
            element-id="amount"
            element-name="amount"
            element-type="tel"
            element-class="`text-center text-xl`"
            element-placeholder="ระบุจำนวนเงินที่ต้องการถอน"
            :amount="amount"
            @updateAmountValue="updateAmountValue"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex">
          <div class="flex-width text-left text-dark">หมายเหตุ</div>
        </div>
        <div class="d-flex py-3">
          <input v-model="remark" type="text" class="form-control" />
        </div>
      </div>

      <div class="col-12 my-3 text-center small">ไปยังบัญชี</div>
      <div class="col-12">
        <div class="card shadow-sm text-white">
          <div class="card-header text-center">
            <img :src="bankLogo" alt="" width="50" /><br />
            <font :class="'text-' + userBank">
              {{ userBankName }}
            </font>
          </div>
          <div class="card-body">
            <div class="container">
              <div class="row">
                <div class="col-6 text-black text-center border-right my-3">
                  ชื่อบัญชี
                </div>
                <div class="col-6 text-center my-3" :class="'text-' + userBank">
                  {{ userBankAccount }}
                </div>
                <div class="col-6 text-black text-center border-right">
                  เลขบัญชี
                </div>
                <div class="col-6 text-center" :class="'text-' + userBank">
                  {{ userBankNumber }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 my-5">
        <button class="btn btn-primary w-100 shadow" type="reset">
          ยกเลิก
        </button>
      </div>
      <div class="col-8 my-5">
        <button class="btn btn-green w-100 shadow" type="submit">ยืนยัน</button>
      </div>
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-12 text-center mt-0 py-3 text-lg text-primary">
        <div class="card py-3">
          <div class="">
            <div class="w-100 text-xxl">คุณมีเวลาโอนเงินภายใน</div>
            <countdown
              type-countdown="cash"
              :seconds-left="secondsLeft"
              class="w-100 text-xxl"
              @game-timeout="gameTimeout"
            />
          </div>
        </div>
      </div>
      <div class="col-12 mt-3 text-xxl text-center text-dark">
        กรุณาโอนเงินจำนวน
      </div>
      <div class="col-12 mt-2 text-success text-center text-h4">
        <font class="text-dark text-xxl"> จำนวน </font>

        {{
          Intl.NumberFormat("th-TH", {
            style: "currency",
            currency: "THB",
          }).format(transactionAmount)
        }}
      </div>
      <div class="col-12 mt-2 text-success text-center">
        <div class="card bg-light text-white">
          <div
            class="card-header text-white text-center text-xxl"
            :class="'bg-' + bankTransactionName"
          >
            ข้อมูลธนาคาร
          </div>
          <div class="card-body py-0 text-lg">
            <div class="d-flex border-bottom py-3">
              <div
                class="flex-width text-center"
                :class="'text-' + bankTransactionName"
              >
                <img :src="bankTransactionLogo" alt="" width="50" /> <br />{{
                  BANKS[bankTransactionName]
                }}
              </div>
            </div>
            <div class="d-flex border-bottom py-3">
              <div class="text-left text-dark justify-content-between">
                ชื่อบัญชี
              </div>
              <v-spacer />
              <div
                class="text-right justify-content-between"
                :class="'text-' + bankTransactionName"
              >
                {{ bankTransactionAccountName }}
              </div>
            </div>
            <div class="d-flex py-3">
              <div class="flex-width text-left text-dark">เลขที่บัญชี</div>
              <div
                class="flex-width text-right text-monospace"
                :class="'text-' + bankTransactionName"
              >
                <input
                  id="bank-id"
                  type="hidden"
                  :value="bankTransactionAccountNumber"
                />
                {{ bankTransactionAccountNumber }}
                <button
                  class="btn btn-outline-success shadow py-1"
                  type="button"
                  @click="copyBankId(bankTransactionAccountNumber)"
                >
                  คัดลอก
                </button>
              </div>
            </div>
            <div class="d-flex py-3">
              <div class="flex-width text-left text-dark">
                ระบุวันเวลาที่ทำรายการโอน
              </div>
            </div>
            <div class="d-flex py-3">
              <select
                id="date"
                required="required"
                class="form-control py-0"
                name="date"
                @change="updateTimeOnChange($event)"
              >
                <option v-for="n in 15" :value="evenTimes(n)">
                  {{ evenTimeMinute(n) }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <ul>
          <li>
            โปรดโอนเงินจำนวน
            <font class="text-success">
              {{ transactionAmount }}
            </font>
            เข้าบัญชี ที่กำหนดไว้
          </li>
          <li>
            ระบบจะแจ้งยอดเงินพร้อมทศนิยมที่ท่านต้องโอน
            ท่านจำเป็นต้องโอนให้ตรงกับยอดนั้น ห้ามปัดเศษเด็ดขาด
          </li>
          <li>
            หลังจากตรวจสอบเรียบร้อยแล้ว ระบบจะทำการ เพิ่มเครดิตให้ท่าน ภายใน 5
            นาที
          </li>
        </ul>
      </div>
    </div>
    <v-dialog v-model="dialogPreload" persistent max-width="290">
      <v-card color="red" dark>
        <v-card-text>
          กำลังประมวลผล
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </form>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "CashRequest",
  props: {
    userBankId: {
      type: Number,
      default: "",
    },
    userBankAccount: {
      type: String,
      default: "",
    },
    userBankNumber: {
      type: String,
      default: "",
    },
    userBankName: {
      type: String,
      default: "",
    },
    userBank: {
      type: String,
      default: "",
    },
    bankLogo: {
      type: String,
      default: "",
    },
    actionType: {
      type: String,
      default: "",
    },
    urlDeposit: {
      type: String,
      default: "",
    },
    urlWithdraw: {
      type: String,
      default: "",
    },
    urlCurrentDeposit: {
      type: String,
      default: "",
    },
    urlConfirm: {
      type: String,
      default: "",
    },
    urlCancel: {
      type: String,
      default: "",
    },
    userId: {
      type: Number,
      default: "",
    },
    agentBanks: {
      type: Array,
      default: "",
    },
  },
  data() {
    return {
      created_at: "",
      remark: "",
      date: null,
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "YYYY-MM-DD hh:mm:ss",
        useCurrent: true,
        // minDate:this.transactionCreate,
        // maxDate:moment(this.expireAt).fromNow(),
        showClear: true,
        showClose: true,
        locale: "th",
      },
      amount: "",
      actionTypeTemp: "",
      bankTransactionId: "",
      bankTransactionName: "",
      bankTransactionAccountNumber: "",
      bankTransactionAccountName: "",
      bankTransactionThaiName: "",
      bankTransactionLogo: "",
      transactionCreate: "",
      transactionAt: "",
      transactionId: "",
      transactionAmount: "",
      expireAt: "",
      secondsLeft: 0,
      timeSet: 0,
      timeLeft: 0,
      selectedAgentBankId: null,
      bankCodeToCopy: "",
      dialogPreload: null,
      submitCash: true,
      submitRequest: true,
      BANKS: {
        bay: "ธนาคารกรุงศรีอยุธยา",
        ktb: "ธนาคารกรุงไทย",
        kbank: "ธนาคารกสิกรไทย",
        scb: "ธนาคารไทยพาณิชย์",
        bbl: "ธนาคารกรุงเทพ",
        tmb: "ธนาคารทีเอ็มบีธนชาต",
      },
    };
  },
  watch: {
    expireAt() {
      this.secondsLeft =
        (moment(this.expireAt).valueOf() -
          moment(this.transactionCreate).valueOf()) /
        1000;
    },
    transactionCreate() {
      this.secondsLeft =
        (moment(this.expireAt).valueOf() -
          moment(this.transactionCreate).valueOf()) /
        1000;
    },
  },
  mounted() {
    const sourcePath = this.bankLogo;
    const lastIndex = sourcePath.lastIndexOf("/");
    this.requiredPath = sourcePath.slice(0, lastIndex + 1);
    const urlPath = this.urlConfirm;
    const lastUrlIndex = urlPath.lastIndexOf("/");
    this.confirmPath = urlPath.slice(0, lastUrlIndex + 1);
    const urlCancelPath = this.urlCancel;
    const lastCancelIndex = urlCancelPath.lastIndexOf("/");
    this.cancelPath = urlCancelPath.slice(0, lastCancelIndex + 1);
    this.actionTypeTemp = this.actionType;

    self = this;
    if (this.actionTypeTemp === "deposit") {
      axios.post(this.urlCurrentDeposit).then((response) => {
        if (response.status === 200) {
          if (response) {
            self.$set(self, "amount", response.data.transaction.amount);
            self.$set(self, "transactionCreate", response.data.current_time);
            self.updateDataTransaction(response.data.transaction);
            self.updateDataBanks(response.data.bank);
            self.updateDataExpireAtCurrent(
              response.data.expire_at,
              response.data.current_time
            );
          }
        }
      });
    }
    Echo.private(`user.${window.appState.user.id}`).listen(
      "cash-transaction-approved",
      this.redirectpage
    );
  },
  methods: {
    copyBankId(data) {
      const bankCodeToCopy = document.querySelector("#bank-id");
      bankCodeToCopy.setAttribute("type", "text");
      bankCodeToCopy.select();
      try {
        const successful = document.execCommand("copy");
        const msg = successful ? "คัดลอกเลขบัญชี" : "unsuccessful";
        Vue.$toast.open({
          message: msg,
          type: "success",
          duration: 5000,
          position: "top-right",
        });
      } catch (err) {}
      bankCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    gameTimeout() {
      this.redirectpage();
    },
    selectedBank(e, bankName, bankId) {
      this.$set(this, "selectedAgentBankId", bankId);
    },
    evenTimes(n) {
      return moment(this.expireAt)
        .subtract(n * -1 + 16, "minutes")
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:00");
    },
    evenTimeMinute(n) {
      return moment(this.expireAt)
        .subtract(n * -1 + 16, "minutes")
        .tz("Asia/Bangkok")
        .format("HH:mm");
    },
    onChange(event) {
      this.$set(this, "selectedAgentBankId", event.target.value);
    },
    updateTimeOnChange(e) {
      console.log(e.target.value);

      this.$set(this, "transactionAt", e.target.value);
    },
    updateAmount(data) {
      this.$set(this, "amount", data);
    },
    updateAmountValue(data) {
      this.$set(this, "amount", data);
    },
    updateDataTransaction(data) {
      this.$set(this, "actionTypeTemp", "confirm");
      this.$set(
        this,
        "transactionCreate",
        moment(data.created_at).tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      );
      this.$set(
        this,
        "transactionAt",
        moment(data.created_at).tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      );
      this.$set(this, "transactionAmount", data.amount);
      this.$set(this, "transactionId", data.id);
    },
    updateDataExpireAt(data) {
      this.$set(this, "expireAt", data);
    },
    updateDataExpireAtCurrent(e, c) {
      this.$set(this, "expireAt", e);
      this.$set(this, "transactionCreate", c);
      this.$set(this, "transactionAt", c);
    },
    updateDataBanks(data) {
      this.$set(this, "bankTransactionId", data.id);
      this.$set(this, "bankTransactionName", data.bank);
      this.$set(this, "bankTransactionAccountNumber", data.account_number);
      this.$set(this, "bankTransactionAccountName", data.account_name);
      this.$set(this, "bankTransactionThaiName", data.thai_name);
      this.$set(this, "bankTransactionLogo", data.logo_url);
    },
    redirectpage(data) {
      window.location.href = "../cash";
    },
    async onSubmit(e) {
      if (this.submitRequest) {
        this.submitRequest = false;
        self = this;
        let postUrl;
        let postData;
        this.dialogPreload = true;
        if (this.amount === 0 || this.amount === "") {
          Vue.$toast.open({
            message: "ระบุเครดิต",
            type: "error",
            duration: 5000,
            position: "top-right",
          });
          this.dialogPreload = false;
          this.submitRequest = true;
          return false;
        }

        if (this.amount < 100 && this.actionTypeTemp === "withdraw") {
          Vue.$toast.open({
            message: "ถอนขั้นต่ำ 100",
            type: "error",
            duration: 5000,
            position: "top-right",
          });
          this.dialogPreload = false;
          this.submitRequest = true;
          return false;
        }

        if (
          this.actionTypeTemp === "deposit" &&
          this.selectedAgentBankId === null
        ) {
          Vue.$toast.open({
            message: "เลือกธนาคาร",
            type: "error",
            duration: 5000,
            position: "top-right",
          });
          this.dialogPreload = false;
          this.submitRequest = true;
          return false;
        }

        if (
          this.actionTypeTemp !== "withdraw" &&
          this.actionTypeTemp !== "deposit"
        ) {
          this.dialogPreload = false;
          this.submitRequest = true;
          return this.onConfirm();
        }

        postUrl =
          this.actionTypeTemp === "withdraw"
            ? this.urlWithdraw
            : this.urlDeposit;
        postData = {
          amount: this.amount,
          bank_id:
            this.actionTypeTemp === "withdraw"
              ? this.userBankId
              : this.selectedAgentBankId,
          remark: this.remark,
        };

        return await axios
          .create({
            headers: { "Cache-Control": "no-store" },
          })
          .post(postUrl, postData)
          .then((response) => {
            if (self.actionTypeTemp === "withdraw") {
              if (response.status === 200) {
                Vue.$toast.open({
                  message: "ยืนยันรายการเรียบร้อย รอการตรวจสอบ",
                  type: "success",
                  duration: 5000,
                  position: "top-right",
                });
              }
              self.redirectpage();
              self.dialogPreload = false;
              self.submitRequest = true;
            } else {
              if (response) {
                self.updateDataTransaction(response.data.transaction);
                self.updateDataBanks(response.data.bank);
                self.updateDataExpireAt(response.data.expire_at);
              }
              self.dialogPreload = false;
              self.submitRequest = true;
            }
          })
          .catch((error) => {
            if (error.response.status === 409) {
              Vue.$toast.open({
                message:
                  "มีรายการ ฝาก-ถอน รอการยืนยัน กรุณาทำรายการใหม่ภายหลัง",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
              // self.redirectpage();
            }
            if (error.response.status === 406) {
              switch (error.response.data.message) {
                case "not sufficient fund":
                  Vue.$toast.open({
                    message: "ถอนเงินเกินบัญชี",
                    type: "error",
                    duration: 5000,
                    position: "top-right",
                  });
                  break;
                case "100 limit":
                  Vue.$toast.open({
                    message: "ถอนขั้นต่ำ 100",
                    type: "error",
                    duration: 5000,
                    position: "top-right",
                  });
                  break;
                case "information not matched":
                  Vue.$toast.open({
                    message: "ระบุข้อมูลไม่ถูกต้อง",
                    type: "error",
                    duration: 5000,
                    position: "top-right",
                  });
                  break;
                case "over limited":
                  Vue.$toast.open({
                    message:
                      "ยอดถอนเกินที่กำหนด ระบบจำกัด " +
                      Intl.NumberFormat("th-TH", {
                        style: "currency",
                        currency: "THB",
                      }).format(error.response.data.limit_tran) +
                      "ต่อครั้งและ " +
                      Intl.NumberFormat("th-TH", {
                        style: "currency",
                        currency: "THB",
                      }).format(error.response.data.limit_daily) +
                      "ต่อวัน",
                    type: "error",
                    duration: 5000,
                    position: "top-right",
                  });
                  break;
                default:
              }
            }
            if (error.response.status === 404) {
              Vue.$toast.open({
                message: "ไม่พบบัญชีธนาคาร",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
            if (error.response.status === 429) {
              Vue.$toast.open({
                message:
                  "คุณทำรายการติดต่อกันหลายครั้ง กรุณารอทำรายการใหม่ภายหลัง",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
            self.dialogPreload = false;
            self.submitRequest = true;
          })
          .finally(() => {
            self.dialogPreload = false;
          });
      }
    },
    async onConfirm() {
      self = this;
      if (this.submitCash) {
        this.dialogPreload = true;
        this.submitCash = false;
        let postUrl = this.confirmPath;
        postUrl += this.transactionId;
        const postData = {
          bank_id: this.bankTransactionId,
          transaction_at: this.transactionAt,
          remark: this.remark,
        };
        return await axios
          .create({
            headers: { "Cache-Control": "no-store" },
          })
          .post(postUrl, postData)
          .then(function (response) {
            if (response.status === 200) {
              Vue.$toast.open({
                message: "ยืนยันรายการเรียบร้อย รอการตรวจสอบ",
                type: "success",
                duration: 5000,
                position: "top-right",
              });
            }
            self.redirectpage();
            this.dialogPreload = false;
            this.submitCash = true;
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              Vue.$toast.open({
                message: "ระบุเวลาไม่ถูกต้อง",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
            if (error.response.status === 406) {
              Vue.$toast.open({
                message: "ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบ",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
            this.dialogPreload = false;
            this.submitCash = true;
          })
          .finally(() => {});
      }
    },
    onCancel() {
      self = this;
      let postUrl = this.cancelPath;
      postUrl += this.transactionId;
      const postData = {
        id: this.transactionId,
      };
      axios
        .post(postUrl, postData)
        .then((response) => {
          if (response.status === 200) {
            Vue.$toast.open({
              message: "ยกเลิกรายการ",
              type: "error",
              duration: 5000,
              position: "top-right",
            });
          }
          self.redirectpage();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            Vue.$toast.open({
              message: "กรุณาลองใหม่",
              type: "error",
              duration: 5000,
              position: "top-right",
            });
          }
        });
    },
  },
};
</script>
